var heading_default = {
  "fontElementMap": "zMFXn",
  "elementSpacing": "LI-hR",
  "headerOne": "JLkq2 LI-hR",
  "headerTwo": "L-PUE LI-hR",
  "headerThree": "ymErU LI-hR",
  "headerFour": "mabWC LI-hR",
  "headerFive": "-MV-o LI-hR",
  "headerSix": "DnKvS LI-hR",
  "child": "_7sCfP"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
